var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIcChevron24 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#ic-chevron-24_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M24 11.848c0-.28-.103-.513-.322-.732L18.41 5.964a.87.87 0 0 0-.644-.26.92.92 0 0 0-.93.917c0 .253.11.485.294.67l4.68 4.55-4.68 4.565a.93.93 0 0 0-.294.67c0 .513.417.924.93.924a.87.87 0 0 0 .644-.267l5.268-5.152a.96.96 0 0 0 .322-.733"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "ic-chevron-24_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h24v24H0z"
})))));
export default SvgIcChevron24;